import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
const formalEnv = location.host.indexOf('cannews.com.cn') > -1 || location.host.indexOf('hkqg.hangkong.com.cn') > -1

axios.defaults.withCredentials = true;
const service = axios.create({
	baseURL: formalEnv ? 'https://hkqg-api.hangkong.com.cn' : 'https://hkqg-test-api.hangkong.com.cn',
	timeout: 10000
})

service.interceptors.request.use(
	config => {
		// 可自定义一些config配置, 可能会调价一些header头
		config.headers.tenantId = 25
		return config
	},
	error => {
		// 处理一些请求出错的情况
		console.log(error)
	}
)

service.interceptors.response.use(
	config => {
		// 可自定义一些config配置
		// 可处理接口状态码进行相关操作
		if (config.status == 200) {
			return config.data
		}
	},
	error => {
		// 处理一些请求出错的情况

		console.log(error)
		//网络中断处理
		if (error.message.indexOf('Network Error') > -1) {
			// 全局的一个提示信息
			Vue.prototype.$message.error('网络中断，请检查网络')
		}
	}
)

const AXIOSWAYS = {
	// get_download
	get_download: (url, params = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'get',
				url: url,
				params: params,
				responseType: 'blob'
			}).then(res => {
				resolve(res)
			}).catch(err => {
				reject(err)
			})
		})
	},
	// get
	get: (url, params = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'get',
				url: url,
				params: params,
			}).then(res => {
				if (res.status == 0) {
					resolve(res.data)
				} else {
					// 全局的一个提示信息
				}
			}).catch(err => {
				reject(err)
			})
		})
	},

	// post
	post: (url, params = {}, isSerialze = true, { getOtherStatusInfo, detailInfo } = {}) => {
		return new Promise((resolve, reject) => {
			service({
				method: 'post',
				url: url,
				data: isSerialze ? qs.stringify(params) : params,
				// 也可以处理一些header头
				// headers: {
				// 	'Content-Type': 'application/x-www-form-urlencoded'
				// }
			}).then(res => {
				if (res.status == 0) {
					resolve(res.data)
				} else if (res.status == 403) {
					reject(res)
				} else {
					if (getOtherStatusInfo) {
						resolve(res)
					}
					if (detailInfo) {
						resolve(res)
					}

					// 全局的一个提示信息
					if (res.status != 509) {
						Vue.prototype.$message.error(res.message)
					}
				}
			}).catch(err => {
				reject(err)
			})
		})
	}
}
var vno = '?vno=3.5.0&';
var timestamp = 'timestamp=' + (+ new Date()) + '&';
// 接口配置
const ApiInfo = {
	getColumnList: '/newsWeb/getAllChannels' + vno, // 获取所有频道列表
	getList: '/newsWeb/getList' + vno + timestamp, // 查看频道下面新闻
	getSubList: '/newsWeb/subject/getList' + vno + timestamp, // 查看专题频道下面的新闻
	getSubjectNewsList: '/newsWeb/subject/getList' + vno + timestamp, // 查看专题
	getNewsDetail: '/newsWeb/getDetail' + vno, // 获取新闻详情
	getNewsDynamic: '/newsWeb/getDynamic' + vno, // 获取新闻相关所属栏目、专题、专栏、融媒号
	getSubject: '/newsWeb/getSubject' + vno + timestamp, // 获取专题列表
	getSubjectTypeInfo: '/newsWeb/getSubjectInfo' + vno, // 获取专题、专栏下的分类列表
	getCategoryNews: '/newsWeb/getCategoryNews' + vno, // 获取分类下的新闻列表
	search: '/newsWeb/search' + vno, // 搜索
	getRMHRecommend: '/newsWeb/platform/getRecommend' + vno, // 获取融媒号推荐列表
	getRMHList: '/newsWeb/platform/accountList' + vno, // 获取融媒号列表
	getNewsWebAdvert: '/newsWeb/getNewsWebAdvert' + vno, //获取type 1、2、3 的广告
	getNewsWebSinkAdvert: '/newsWeb/getNewsWebSinkAdvert' + vno,

	getBanner: '/counterRumour/banner/list', // 获取首页banner
	getIndexNewsList: '/counterRumour/index/list', // 获取首页新闻列表
	getColumnNews: '/counterRumour/column/newsList', // 获取栏目新闻列表
	getRecommendColumn: '/counterRumour/column/recommend/list', // 获取首页推荐栏目列表
	getSubjects: '/counterRumour/subject/list', // 获取专题列表
	getSubjectDetail: '/counterRumour/subject/detail', // 获取专题详情
	getSearchResult: '/counterRumour/search/list', // 获取搜索结果
	getRecommendNews: '/counterRumour/relate/newsList', // 获取推荐新闻列表
	getNextNews: '/counterRumour/news/next', // 获取下一篇新闻
	getWeChatConf: '/wap/counterRumour/weixin/getConf', // 获取微信分享配置信息
	getGroupList: '/counterRumour/column/groupList', // 获取分类列表
	getColumnSubjects: '/counterRumour/getColumnSubjects', // 获取专题专栏集合栏目
	getSubjectList: '/counterRumour/column/subject/list', // 获取专题列表新闻
	getChannelNewsList: '/counterRumour/news/channelNewsList', // 获取频道下新闻列表

	getInitSetting: '/newsWeb/home/getInitSetting', // 获取皮肤
	getQrCode: '/newsWeb/sendVcode',//获取二维码
	login: '/newsWeb/mediaUser/login',//登录
	userSubmit: '/newsWeb/mediaUser/submit', //提交用户信息
	getUploadToken: "/wap/upload/token", // 七牛云token
	mediaFileList: "/wap/mediaFile/list", //媒体文件列表
	cancelAccount: "/newsWeb/mediaUser/cancelAccount", // 登出
	logout: "/newsWeb/mediaUser/logout",
	getUserInfo: "/newsWeb/mediaUser/getUserInfo", // 获取媒体用户信息
	getSysnotice: "/newsWeb/getSysnotice", // 获取媒体用户信息
	getMessageCount:'/newsWeb/getMessageCount', // 获取消息数量
}

// if(common.Attribute.isMb()) { // 一开始以为wap接口要加上wap前缀，最后商定和pc走一样的接口
// 	for(let key in ApiInfo) {
// 		ApiInfo[key] = `wap${ApiInfo[key]}`
// 	}
// }

export { AXIOSWAYS, ApiInfo }